import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "damage-report-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "error-message"
}
const _hoisted_3 = {
  key: 1,
  class: "loading-info"
}
const _hoisted_4 = {
  key: 2,
  class: "no-data"
}
const _hoisted_5 = { class: "img-list" }
const _hoisted_6 = ["href"]

import { ref, onMounted } from 'vue'
import { getEvCarDamageReports, markDamageReportResolved } from '@/api/ev-trips'
import { getUserDetails } from '@/api/user'
import { EvTripExtended } from '@/models/evTrip'
import { DamageReport } from '@/api/car-ev-data'

interface User {
  id: string
  first_name: string
  last_name: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EvTripDamageReport',
  props: {
    trip: {}
  },
  emits: ["update-opened-count"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const reports = ref<DamageReport[]>([])
const users = ref<Record<string, User>>({})
const loading = ref(false)
const error = ref('')

const fetchReports = async () => {
  loading.value = true
  error.value = ''
  try {
    const response = await getEvCarDamageReports(props.trip.id)
    reports.value = response.data.data

    const opened = reports.value.filter(r => r.status === 'opened').length
    emit('update-opened-count', opened)

    const uniqueUserIds = [...new Set(reports.value.map(r => r.user_id))]

    await Promise.all(
      uniqueUserIds.map(async userId => {
        if (!users.value[userId]) {
          try {
            const res = await getUserDetails(userId)
            const userData: User = {
              id: res.data.data.id,
              first_name: res.data.data.first_name || '',
              last_name: res.data.data.last_name || '',
            }
            users.value[userId] = userData
          } catch (userErr) {
            console.error(`❌ Failed to fetch user ${userId}`, userErr)
          }
        }
      })
    )
  } catch (err) {
    console.error('❌ Failed to load damage reports:', err)
    error.value = 'Failed to load damage reports'
  } finally {
    loading.value = false
  }
}

const markResolved = async (reportId: string) => {
  try {
    await markDamageReportResolved(reportId)
    const target = reports.value.find(r => r.id === reportId)
    if (target) target.status = 'resolved'

    const opened = reports.value.filter(r => r.status === 'opened').length
    emit('update-opened-count', opened)
  } catch (err) {
    console.error('❌ Failed to mark report as resolved:', err)
  }
}

onMounted(fetchReports)

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Loading damage reports... "))
      : _createCommentVNode("", true),
    (!loading.value && !error.value && reports.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No damage reports found for this trip "))
      : _createCommentVNode("", true),
    (reports.value.length)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 3,
          data: reports.value,
          style: {"width":"100%"},
          class: "damage-reports-table"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "created_at",
              label: "Created At",
              width: "180"
            }),
            _createVNode(_component_el_table_column, {
              prop: "description",
              label: "Description"
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "Status",
              width: "120"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tag, {
                  type: row.status === 'resolved' ? 'success' : 'danger'
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.status), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, { label: "Images" }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.images, (img) => {
                    return (_openBlock(), _createBlock(_component_el_image, {
                      key: img.public_id,
                      src: img.secure_url,
                      "preview-src-list": [img.secure_url],
                      style: {"width":"60px","height":"60px","margin-right":"8px"},
                      fit: "cover"
                    }, null, 8, ["src", "preview-src-list"]))
                  }), 128))
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "User",
              width: "200"
            }, {
              default: _withCtx(({ row }) => [
                (users.value[row.user_id])
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: `/ev-users/${row.user_id}`,
                      target: "_blank",
                      style: {"text-decoration":"underline"}
                    }, _toDisplayString(users.value[row.user_id].first_name) + " " + _toDisplayString(users.value[row.user_id].last_name), 9, _hoisted_6))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Loading...")
                    ], 64))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Actions",
              width: "150"
            }, {
              default: _withCtx(({ row }) => [
                (row.status === 'opened')
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "primary",
                      size: "small",
                      onClick: ($event: any) => (markResolved(row.id))
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" Resolved ")
                      ])),
                      _: 2,
                      __: [0]
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})